"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (locale) {
  switch (locale && locale.toLowerCase()) {
    case "he":
      return function (n) {
        return n === 1 ? 0 : 1;
      };
    case "en":
    default:
      return function (n) {
        return n === 1 ? 0 : 1;
      };
  }
};


